import { render, staticRenderFns } from "./EditImportPage.vue?vue&type=template&id=bc1bc61a"
import script from "./EditImportPage.vue?vue&type=script&lang=js"
export * from "./EditImportPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports